module.exports = [["MON - FRI","11:00-15:00, 18:00-23:00"],["SAT - SUN","10:30-23:30"],["WEDNESDAY","closed"]]